/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['ViewModel'];
const factory = function (ViewModel) {
  let ClientInfoVM;
  return (ClientInfoVM = class ClientInfoVM extends ViewModel {
    $listenTransformFn(data) {
      // make sure members is a number as historical data may be inconsistent
      return _(data)
        .assign({ members: _.parseInt(data.members) || undefined })
        .value();
    }
  });
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.viewmodel.clientinfo', moduleDeps)
  .factory('ClientInfoVM', factory);
